import React, { useRef, useEffect, useState } from "react";
import "./VideoDemo.css";

const VideoDemo = () => {
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Video/audio synchronization
  useEffect(() => {
    const video = videoRef.current;
    const audio = audioRef.current;

    if (!video || !audio) return;

    const handlePlay = () => {
      audio.currentTime = video.currentTime; // Synchronize times
      audio
        .play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch(console.error);
    };

    const handlePause = () => {
      audio.pause();
      setIsPlaying(false);
    };

    const handleEnded = () => {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
    };

    const handleTimeUpdate = () => {
      // Maintain synchronization during playback
      if (isPlaying && Math.abs(audio.currentTime - video.currentTime) > 0.1) {
        audio.currentTime = video.currentTime;
      }
    };

    // Video events
    video.addEventListener("play", handlePlay);
    video.addEventListener("pause", handlePause);
    video.addEventListener("ended", handleEnded);
    video.addEventListener("timeupdate", handleTimeUpdate);

    return () => {
      video.removeEventListener("play", handlePlay);
      video.removeEventListener("pause", handlePause);
      video.removeEventListener("ended", handleEnded);
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [isPlaying]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        padding: "24px 0",
      }}
    >
      {/* Main video */}
      <video
        ref={videoRef}
        controls
        src="/18159ca1-1299-4d81-ba3b-93af443c3d1a.webm"
        style={{
          width: "100%",
          aspectRatio: "16/9",
          borderRadius: "12px",
          background: "#000",
        }}
      >
        <track
          src="/subtitles.vtt"
          kind="subtitles"
          srclang="en"
          label="English"
          default
        />
        Your browser does not support the video tag.
      </video>

      {/* Hidden but synchronized audio */}
      <audio
        ref={audioRef}
        src="/Ambiment-fixed.mp3"
        style={{ display: "none" }}
      />

      {/* Status indicator */}
      <div
        style={{
          marginTop: "10px",
          fontSize: "14px",
          color: isPlaying ? "#4CAF50" : "#666",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: isPlaying ? "#4CAF50" : "#ccc",
            animation: isPlaying ? "pulse 1s infinite" : "none",
          }}
        ></div>
        {isPlaying ? "🎵 Music playing..." : "⏸️ Musique en pause"}
      </div>

      <style>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default VideoDemo;
